const action = {
    general: 'İşlem çalıştırılırken bir hata oluştu. Lütfen daha sonra yeniden deneyin.',
    sign_in_identifier_changed: 'İşlem, bu doğrulamada kullanılan oturum açma tanımlayıcısını değiştiremez.',
};
export default Object.freeze(action);
